module.exports = __webpack_public_path__ + "static/1-d9ae36d94d37ab7aa94b4a4ad81b0228.jpg";